module.exports = __webpack_public_path__ + "static/media/commerce.f7fde8bb.jpg";